export default "__VITE_ASSET__32c7cfec__"